import Rest from 'tools/rest';

function urlBase64ToUint8Array(base64String) {
  if (!base64String) return null;
  const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
  const rawData = window.atob(base64);
  const outputArray = new Uint8Array(rawData.length);
  for (let i = 0; i < rawData.length; ++i) {
    outputArray[i] = rawData.charCodeAt(i);
  }
  return outputArray;
}

/**
 * Регистрация Service Worker и подписка на Web Push (после успешной авторизации).
 */
export function initWebPush() {
  if (!('serviceWorker' in navigator) || !('PushManager' in window)) {
    return;
  }
  if (typeof Notification === 'undefined') {
    return;
  }

  Rest.get('/api/v1/web_push/vapid_public_key.json').then((response) => {
    const json = response.data;
    if (!json || !json.configured || !json.public_key) {
      return;
    }

    const vapidPublicKey = json.public_key;

    const permission =
      typeof Notification !== 'undefined' && Notification.permission === 'default'
        ? Notification.requestPermission()
        : Promise.resolve(typeof Notification !== 'undefined' ? Notification.permission : 'denied');

    permission
      .then((p) => {
        if (p === 'denied') return Promise.reject(new Error('notifications denied'));
        return navigator.serviceWorker.register('/service-worker.js');
      })
      .then(() => navigator.serviceWorker.ready)
      .then((registration) => registration.pushManager.getSubscription())
      .then((existing) => {
        if (existing) return existing;
        return navigator.serviceWorker.ready.then((registration) =>
          registration.pushManager.subscribe({
            userVisibleOnly: true,
            applicationServerKey: urlBase64ToUint8Array(vapidPublicKey),
          }),
        );
      })
      .then((subscription) => {
        if (!subscription) return;

        const subJson = subscription.toJSON();
        const keys = subJson.keys || {};
        Rest.post('/api/v1/push_subscriptions.json', {
          push_subscription: {
            endpoint: subJson.endpoint,
            p256dh: keys.p256dh,
            auth: keys.auth,
          },
        }).then(() => {});
      })
      .catch((err) => {
        if (process.env.NODE_ENV !== 'production') {
          console.warn('[WebPush]', err);
        }
      });
  });
}
